import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BookingContext = createContext(null);
export const useBooking = () => useContext(BookingContext);

export const BookingProvider = ({ children }) => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  const fetchVehicles = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/vehicles`);
      setVehicles(res.data);
    } catch (e) {
      console.error("Failed to load vehicles", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchVehicles();
  }, [fetchVehicles]);

  const openBooking = useCallback((vehicle = null) => {
    setSelectedVehicle(vehicle);
    setOpen(true);
  }, []);

  const value = { vehicles, loading, open, setOpen, selectedVehicle, openBooking, API };
  return <BookingContext.Provider value={value}>{children}</BookingContext.Provider>;
};
